import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { api } from '../../lib/api';
import { Check, X, Loader2, AlertTriangle } from 'lucide-react';
import { Button } from '../../components/ui/button';

const CancelPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const email = searchParams.get('email') || '';

  const [status, setStatus] = useState('loading'); // loading, confirm, success, error, already
  const [resa, setResa] = useState(null);
  const [canceling, setCanceling] = useState(false);

  useEffect(() => {
    api.get(`/resa/reservations/${id}`)
      .then(r => {
        setResa(r.data);
        if (r.data.status === 'canceled') {
          setStatus('already');
        } else {
          setStatus('confirm');
        }
      })
      .catch(() => setStatus('error'));
  }, [id]);

  const handleCancel = async () => {
    setCanceling(true);
    try {
      await api.post(`/resa/reservations/${id}/cancel?token=${token}&email=${encodeURIComponent(email)}`);
      setStatus('success');
    } catch {
      setStatus('error');
    }
    setCanceling(false);
  };

  const MOIS = ['Janvier','Fevrier','Mars','Avril','Mai','Juin','Juillet','Aout','Septembre','Octobre','Novembre','Decembre'];

  return (
    <div className="min-h-screen bg-[rgb(var(--lm-bg))] flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center" data-testid="cancel-page">
        {status === 'loading' && <Loader2 className="w-8 h-8 animate-spin text-[rgb(var(--lm-gold))] mx-auto" />}

        {status === 'confirm' && resa && (
          <>
            <AlertTriangle size={40} className="text-[rgb(var(--lm-orange))] mx-auto mb-4" />
            <h1 className="font-title text-xl text-[rgb(var(--lm-text))] mb-2">Annuler votre reservation ?</h1>
            <div className="lm-card p-5 text-left space-y-2 my-6">
              <p className="text-sm text-[rgb(var(--lm-text))]"><strong>{resa.guest_name}</strong></p>
              <p className="text-sm text-[rgb(var(--lm-text-secondary))]">
                {(() => { const d = new Date(resa.date + 'T00:00:00'); return `${d.getDate()} ${MOIS[d.getMonth()]}`; })()} a {resa.time_slot}
              </p>
              <p className="text-sm text-[rgb(var(--lm-text-secondary))]">{resa.guests_count} convives</p>
            </div>
            <div className="flex gap-3">
              <Button onClick={() => window.history.back()} variant="outline" className="flex-1 border-[rgb(var(--lm-border))]">
                Non, garder
              </Button>
              <Button onClick={handleCancel} disabled={canceling}
                className="flex-1 bg-[rgb(var(--lm-red))] text-white hover:opacity-90" data-testid="confirm-cancel">
                {canceling ? <Loader2 size={14} className="animate-spin" /> : 'Oui, annuler'}
              </Button>
            </div>
          </>
        )}

        {status === 'success' && (
          <>
            <Check size={40} className="text-[rgb(var(--lm-green))] mx-auto mb-4" />
            <h1 className="font-title text-xl text-[rgb(var(--lm-text))] mb-2">Reservation annulee</h1>
            <p className="text-sm text-[rgb(var(--lm-text-muted))]">Votre reservation a bien ete annulee.</p>
          </>
        )}

        {status === 'already' && (
          <>
            <X size={40} className="text-[rgb(var(--lm-text-muted))] mx-auto mb-4" />
            <h1 className="font-title text-xl text-[rgb(var(--lm-text))] mb-2">Deja annulee</h1>
            <p className="text-sm text-[rgb(var(--lm-text-muted))]">Cette reservation a deja ete annulee.</p>
          </>
        )}

        {status === 'error' && (
          <>
            <X size={40} className="text-[rgb(var(--lm-red))] mx-auto mb-4" />
            <h1 className="font-title text-xl text-[rgb(var(--lm-text))] mb-2">Erreur</h1>
            <p className="text-sm text-[rgb(var(--lm-text-muted))]">Lien invalide ou reservation introuvable.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default CancelPage;
